var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 0.625C13.75 0.46875 14 0.46875 14.125 0.625L15.0312 1.5C15.1562 1.65625 15.1562 1.90625 15.0312 2.03125L5.65625 11.4062C5.5 11.5625 5.28125 11.5625 5.125 11.4062L0.9375 7.25C0.8125 7.09375 0.8125 6.84375 0.9375 6.71875L1.84375 5.8125C1.96875 5.6875 2.21875 5.6875 2.375 5.8125L5.375 8.84375L13.5938 0.625Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.127c8b47.svg";
export { ForwardRef as ReactComponent };